import { Stack } from '@mui/material';
import APIDefinitions from 'components/api-definitions/api-definitions.component';
import apiDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/loyalty-performance-api-defintitions';
import { useTranslation } from 'react-i18next';

const membershipDefinitions = [
  apiDefinitions.activeMembers,
  apiDefinitions.activeMemberPercent,
  apiDefinitions.systemActiveMemberPercent,
];

const loyaltyOrdersDefinitions = [
  apiDefinitions.loyaltyOrdersNetSales,
  apiDefinitions.loyaltyContributionPercentOfSales,
  apiDefinitions.systemContributionRate,
];

const FranchiseLoyaltyApiDefinitions = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2}>
      <APIDefinitions
        type={t(
          'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.apiDefinitionsDrawer.membership.label',
        )}
        definitions={membershipDefinitions}
      />
      <APIDefinitions
        type={t(
          'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.apiDefinitionsDrawer.loyaltyOrders.label',
        )}
        definitions={loyaltyOrdersDefinitions}
      />
    </Stack>
  );
};

export default FranchiseLoyaltyApiDefinitions;
